<template>
  <vue-drawer-layout ref="drawer" :drawer-width="300" @mask-click="closeDrawer">
    <div slot="drawer">
      <NavigationDrawer :close="closeDrawer" class="navigation-drawer"/>
    </div>
    <div slot="content">
      <NavigationBar :toggle="openDrawer" class="nav"/>
      <div class="navigation-route-view">
        <router-view/>
      </div>
    </div>
  </vue-drawer-layout>
</template>

<script>
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer";
import NavigationBar from "@/components/layout/navigation/NavigationBar";

export default {
  name: "Layout",
  computed: {},
  components: {NavigationBar, NavigationDrawer},
  methods: {
    toggleDrawer() {
      this.$refs.drawer.toggle();
    },
    openDrawer() {
      this.$refs.drawer.toggle();
    },
    closeDrawer() {
      this.$refs.drawer.toggle(false);
    }
  }

}
</script>

<style lang="scss" scoped>
.root-pane {
  // display: flex;
  // flex-direction: column;
  // justify-content: space-evenly;
}

.navigation-drawer {
  min-width: 285px;
  width: 100%;
  height: 100vh;
}

.navigation-route-view {
  transition: 0.5s ease;
}

.burger {
  width: 40px;
  height: 40px;
  background: transparent;

  font-size: 30px;
}
</style>
